import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import '../scss/styles.scss';


@Component({})
export default class Toast extends Vue {
  @Prop({
    type: String,
    required: false,
    default: '',
  }) html!: string;

  @Prop({
    type: Number,
    required: false,
    default: 4000,
  }) displayLength!: number;

  @Prop({
    type: String,
    required: false,
    default: '',
  }) classes!: string;

  @Prop({
    type: Boolean,
    required: true,
    default: false,
  }) display!: boolean;

  private timeout = -1;

  dismiss() {
    clearTimeout(this.timeout);
    this.toastComplete();
  };

  toastComplete() {
    this.$emit('completed');
  };

  @Watch('display')
  onDisplayChanged(val: boolean) {
    if (val) {
      // @ts-ignore
      this.timeout = setTimeout(this.toastComplete, this.displayLength);
    }
  }
}
